import { Theme } from "@/types";

export const setTheme = (theme?: Theme) =>
  theme ? { "data-theme": theme } : {};
